import { FormField, FormFieldCategory } from '@la/types';
import baseApi from './baseApi';

export const formFieldsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFormFields: builder.query<
      FormField[],
      { category?: FormFieldCategory; programId: string; siteDomain: string }
    >({
      query: ({ category, programId, siteDomain }) => ({
        url: `/api/member-portal/${siteDomain}/registrations/form-fields`,
        method: 'GET',
        params: { category, programId },
      }),
    }),
  }),
});

export const { useGetFormFieldsQuery } = formFieldsApi;
